// removed by extract-text-webpack-plugin
module.exports = {"h3":"markdown-module__h3___2WXYc","li":"markdown-module__li___2Vkgq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/markdown/markdown.module.scss
// module id = 237
// module chunks = 0